import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { SiteLayout } from "../components/site/SiteLayout";

const CATS = [["initial", "聲母", "bg-red-50 border-red-200 text-red-900"], ["medial", "介音", "bg-green-50 border-green-200 text-green-900"], ["final", "韻母", "bg-amber-50 border-amber-200 text-amber-900"]];
const TONES = [["一聲", "媽", "ㄇㄚ", "#EF4444", "平平的，高高的"], ["二聲", "麻", "ㄇㄚˊ", "#3B82F6", "往上揚，像問問題"], ["三聲", "馬", "ㄇㄚˇ", "#10B981", "先下去再上來"], ["四聲", "罵", "ㄇㄚˋ", "#8B5CF6", "從高快快往下"], ["輕聲", "嗎", "˙ㄇㄚ", "#6B7280", "輕輕短短的"]];
const HANZI = [["看圖認字", "每個字都有圖畫，「象」就是一頭大象。", "🐘"], ["筆順動畫", "一筆一畫慢慢示範，從上到下、從左到右。", "✍️"], ["手指描寫", "跟著紅線描一描，完成就有星星。", "⭐"], ["詞語句子", "一個字搭配詞語和短句，學了馬上會用。", "📖"]];

export default function Learn() {
  const [zy, setZy] = useState([]);
  useEffect(() => { api.get("/public/zhuyin").then(({ data }) => setZy(data)).catch(() => {}); }, []);
  return (
    <SiteLayout>
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-14 space-y-16 font-serif-tc" data-testid="learn-page">
        <header>
          <h1 className="text-4xl sm:text-5xl font-black text-[var(--vermilion)]">注音與文字學習</h1>
          <p className="text-lg text-stone-700 mt-4 max-w-3xl leading-relaxed">我們用注音符號（ㄅㄆㄇ）帶孩子認識國語發音，再透過故事學習繁體中文字。每一課只學三到五個新注音、六到八個新字，循序漸進，不會有壓力。</p>
        </header>
        <section data-testid="learn-zhuyin">
          <h2 className="text-3xl font-black text-[var(--tea)]">三十七個注音符號</h2>
          <p className="text-stone-600 mt-2">分成聲母、介音和韻母，分散在第一課到第九課學習，第十課做總復習；之後的新故事也會不斷複習。</p>
          <div className="space-y-6 mt-6">
            {CATS.map(([k, label, cls]) => (
              <div key={k}>
                <div className="font-bold text-lg mb-2">{label}（{zy.filter((z) => z.category === k).length}個）</div>
                <div className="flex flex-wrap gap-2">
                  {zy.filter((z) => z.category === k).map((z) => (
                    <div key={z.symbol} title={`${z.example_character} ${z.example_zhuyin}`} className={`w-16 h-16 rounded-2xl border-2 flex flex-col items-center justify-center ${cls}`}>
                      <span className="text-3xl font-black leading-none">{z.symbol}</span>
                      <span className="text-sm">{z.image_asset}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>
        <section data-testid="learn-tones">
          <h2 className="text-3xl font-black text-[var(--tea)]">五個聲調</h2>
          <p className="text-stone-600 mt-2">聲調慢慢介紹，孩子用耳朵聽、用眼睛看聲調符號，再玩「聽聲調選注音」的遊戲。</p>
          <div className="grid grid-cols-2 sm:grid-cols-5 gap-4 mt-6">
            {TONES.map(([n, ch, z, c, d]) => (
              <div key={n} className="scroll-card p-5 text-center" style={{ borderColor: c }}>
                <div className="font-bold" style={{ color: c }}>{n}</div>
                <div className="text-5xl font-black mt-2">{ch}</div>
                <div className="text-xl font-bold mt-1" style={{ color: c }}>{z}</div>
                <div className="text-sm text-stone-500 mt-2">{d}</div>
              </div>
            ))}
          </div>
        </section>
        <section data-testid="learn-hanzi">
          <h2 className="text-3xl font-black text-[var(--tea)]">繁體字學習</h2>
          <p className="text-stone-600 mt-2">每個故事學六到八個常用繁體字，故事會持續增加，例如：梨、水、石、象、船、兔、山、虎、蛇、蛙。</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-6">
            {HANZI.map(([t, d, e]) => (
              <div key={t} className="scroll-card p-6">
                <div className="text-5xl">{e}</div>
                <div className="text-2xl font-black mt-3">{t}</div>
                <p className="text-stone-600 mt-2">{d}</p>
              </div>
            ))}
          </div>
        </section>
        <section className="scroll-card p-8" data-testid="learn-mastery">
          <h2 className="text-2xl font-black text-[var(--tea)]">怎樣才算「學會」？</h2>
          <p className="text-stone-700 mt-3 leading-relaxed">完成一課不等於學會。系統會記錄每個注音和國字的練習次數與正確率，至少練習三次、正確率達到八成，才會標示為「已精熟」。需要加強的項目會自動列在家長的學習報告裡。</p>
        </section>
      </div>
    </SiteLayout>
  );
}
